export const paths = {
  events: '/promote/events',
  offers: '/promote/offers',
  news: '/promote/news',
};
